'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {
	return {
		downloadQuotationComparison: $resource(
			`${apiConfig.$get().apiUrl}/quotation?rfqGroupId=:rfqGroupId`,
			{
				rfqGroupId: '@rfqGroupId'
			},
			{
				query: {
					method: 'GET',
					responseType: 'arraybuffer',
					transformResponse: function(data, headersGetter) {
						return {
							data: data,
							headers: headersGetter
						}
					}
				}
			}
		)
	}
}
